import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";

import Logo from "../../../assets/logo.png";
import { Title } from "../../../Components/Typography";
import { Button } from "../../../Components/Button";
import { Input } from "../../../Components/Input";
import useResponsive from "../../../hooks/useResponsive";
import { useLogin } from "../../../Contexts/LoginAdminContext"; // Importa el hook del contexto

export const Login = () => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();
  const { email, password, loading, setEmail, setPassword, onClickLogin } = useLogin(); // Usa el contexto

  useEffect(() => {
    document.title = "El Rayo (Admin)";
  }, []);

  return (
    <div className={isDesktopOrLaptop ? "admin-login-desktop" : "admin-login-mobile"}>
      <img alt="logo" src={Logo} />

      <div className="column-form">
        <Title>Admin</Title>

        <div className="order-section">
          <Input
            title="Usuario"
            value={email}
            onChange={(text: string) => setEmail(text)}
          />

          <Input
            title="Contraseña"
            type="password"
            value={password}
            onChange={(text: string) => setPassword(text)}
          />
          <Button onClick={() => onClickLogin(navigate)} disabled={loading}>
            {loading ? "Cargando..." : "Ingresar"}
          </Button>
        </div>
      </div>
    </div>
  );
};